import template from './videoMonitoring.html';

/* @ngInject */
function VideoMonitoringController(
  $scope,
  $sails,
  growl,
  $timeout,
  MonitoringService,
  monitoringGridFactory
) {
  const vm = this;

  /// ////////////////
  // Local Variables//
  /// ////////////////
  const defaultGridSettings = {
    enableColumnMenus: false,
    enableFiltering: true,
    enableGridMenu: true,
    enableRowHeaderSelection: false,
    enableRowSelection: false,
    enableSelectAll: false,
    exporterMenuExcel: false,
    exporterMenuPdf: false,
    modifierKeysToMultiSelect: true,
    showColumnFooter: false,
    showGridFooter: true,
  };
  const ttl = 3000;
  const GRID_RESIZE_DELAY = 700;

  init();
  /// //////////////////////////////
  // Hoisted Function Declarations//
  /// //////////////////////////////

  async function init() {
    vm.grids = [
      'videoStatsGrid',
      'videoStatsGrid2',
    ].map((grid) => {
      // (Assign to VM for specific reference in template)
      vm[grid] = _.defaults(monitoringGridFactory(grid), defaultGridSettings);
      vm[grid].name = grid;
      onGridRegister(vm[grid]);
      return vm[grid];
    });

    populateReport(await MonitoringService.eventInfo('cameras/status'));

    $scope.$on('$destroy', handleDestroy);
    $sails.on('cameras/status', handleSocketNewReport);

    MonitoringService
      .joinRoom()
      .catch(err => console.error('Could not join monitoring room', err));

    // Toggle this column to visible false; only add it so we can link filtering on this column as well.
    vm.grids[1].columnDefs[2].visible = false;
  }

  function populateReport(report) {
    vm.grids.forEach(grid => _.set(grid, 'data', report));
  }

  function onGridRegister(grid) {
    grid.onRegisterApi = (gridApi) => {
      grid.api = gridApi;
      // this call fixes the issue with the grid rendering smaller on page load
      $timeout(() => grid.api.core.handleWindowResize(), GRID_RESIZE_DELAY);
      gridApi.core.on.filterChanged($scope, () => filterChanged(grid));
    };
  }

  function filterChanged(sourceGrid) {
    const { api: source } = sourceGrid;
    const otherGrids = _.filter(vm.grids, grid => grid.name !== sourceGrid.name);

    const propagateFilter = (col) => {
      const { term } = source.grid.columns[col].filters[0];
      otherGrids.forEach(({ api: other }) => {
        other.grid.columns[col].filters[0].term = term;
      });
    };

    _.times(3, propagateFilter);
    otherGrids.forEach(({ api: other }) => other.core.refresh());
  }

  function handleSocketNewReport(newReport) {
    growl.info('A new report is here!', { ttl });
    populateReport(newReport);
  }

  function handleDestroy() {
    $sails.off('cameras/status', handleSocketNewReport);
    MonitoringService.leaveRoom();
  }
}

export default {
  name: 'videoMonitoringComponent',
  template,
  controller: VideoMonitoringController
};
